import { jsx as _jsx } from "react/jsx-runtime";
import { mergeRefs } from '@/helpers/mergeRefs';
import useAnimateFade from '@/hooks/useAnimateFade';
import { useIsClient } from '@/hooks/useIsClient';
import { getAnchorNavIdFromTitle } from '@/utils/anchorNav';
import { applyBottomPadding, applyCentreTheme, applyTheme, applyTopPadding } from '@/utils/themeUtils';
import clsx from 'clsx';
import { forwardRef, useRef } from 'react';
const showAfterHydrationClass = '[&_*[data-show-after-hydration]]:opacity-0';
const SectionWrapper = forwardRef(({ children, className, topPadding, bottomPadding, width = 'contained', centreTheme, theme, anchorNavTitle, enableAnimations = false, ...otherProps }, forwardedRef) => {
    const ref = useRef(null);
    const isClient = useIsClient();
    useAnimateFade(ref, enableAnimations);
    return (_jsx("section", { ref: mergeRefs(ref, forwardedRef), className: clsx('scroll-mt-(--header-offset)', width === 'contained' && 'site-container', applyTopPadding(topPadding), applyBottomPadding(bottomPadding), applyCentreTheme(centreTheme), applyTheme(theme), 
        /*
         * Components are rendered on the server, some interactive parts of the site don't run until hydration. This
         * means elements are visible in an incorrect position for a split second before they are moved.
         * A `data-show-after-hydration` attribute exists which sets the elements opacity to 0 by default. This
         * effect removes the class, meaning the children are not hidden.
         */
        !isClient && showAfterHydrationClass, className), "data-anchor-nav-id": getAnchorNavIdFromTitle(anchorNavTitle), id: getAnchorNavIdFromTitle(anchorNavTitle), ...otherProps, children: children }));
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
